import * as R from 'ramda';
export function safeConcat(item1, item2) {
    return R.ifElse(R.is(Object), R.concat(R.__, item2), R.concat(R.__, String(item2)))(item1);
}
export function concatAll(...args) {
    return R.reduce(safeConcat, R.empty(args[0]), args);
}
export function concatN(n, ...args) {
    return R.curryN(n, concatAll)(...args);
}
